export function popup() {
    let video;
    let curSrc;
    let $modal = $(".popup");
    let openBtn = $(".open-modal, .open-bio-popup");
    let closeBtn = $modal.find(".close-btn");
    let $videoContainer = $modal.find(".video-container");

    openBtn.on("click", function (e) {
        e.preventDefault();

        if ($(this).attr("data-src-video")) {
            curSrc = $(this).attr("data-src-video");

            if (curSrc.slice(curSrc.length - 3) !== "mp4") {
                let srcDefaults = "autoplay=1&mute=0";
                let src = curSrc + (curSrc.indexOf("?") > -1 ? "&" : "?") + srcDefaults;
    
                video = $("<iframe src='" + src + "' allow='accelerometer; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>");
            } else {
                video = $("<video class='video' preload='metadata' autoplay muted playsinline controls><source src='" + curSrc + "' type='video/mp4'></video>");
            }

            $videoContainer.append(video);
            $(".video-popup").addClass("open");
        } else {
            $(".bio-popup").addClass("open");
        }
    });

    closeBtn.on("click", function () {
        $modal.removeClass("open");

        setTimeout(() => {
            if ($videoContainer.length) {
                $videoContainer.empty();
            }
        }, 100);
    });

    $(document).on("keydown", function (event) {
        if (event.keyCode == 27) {
            $modal.removeClass("open");

            setTimeout(() => {
                if ($videoContainer.length) {
                    $videoContainer.empty();
                }
            }, 100);
        }
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/popup.js